<template>
  <div class="d-flex" style="height: 100vh; margin-top: -1.85em">
    <div
      style="width: 50%"
      class="d-flex flex-column justify-content-between gradient-vertical"
    >
      <div class="mt-5 text-center">
        <img src="/images/Frame3839.png" alt="Logo" width="170px" />
      </div>

      <div class="my-auto text-start" style="margin: 0 auto; width: 400px">
        <div class="mb-4" v-if="!isOtpSent">
          <span class="fw-bold fs-3 d-block">Sign In</span>
          <span class="subtitle"
            >Enter Your phone Number and OTP to sign in!</span
          >
        </div>

        <form @submit.prevent="sendOTP" v-if="!isOtpSent">
          <div>
            <label for="email">Phone Number *</label>
            <input
              class="form-control"
              style="border-radius: 12px; height: 50px"
              v-model="phone"
              id="email"
              maxlength="10"
              @input="v$.phone.$touch()"
              placeholder="Enter Your Number"
            />
            <div class="error-message text-danger">
              <span v-if="v$.phone.$errors.length">
                {{ v$.phone.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div
            :class="'alert alert-' + msgType + ' mb-xl-0 mt-2'"
            role="alert"
            v-if="msgTxt && msgTxt.length > 0"
          >
            {{ msgTxt }}
          </div>

          <div class="mt-3">
            <button
              class="btn w-100"
              style="border-radius: 12px; height: 50px"
              :class="{
                'btn-warning': !v$.$invalid,
                'disabled-btn': v$.$invalid,
              }"
              type="submit"
              :disabled="v$.$invalid"
            >
              <div v-if="loading" class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span v-else class="fw-bold">SEND OTP</span>
            </button>
          </div>
        </form>

        <div class="col-lg-6" v-else style="margin: 0 auto; width: 400px">
          <div class="d-flex justify-content-center align-items-center">
            <div class="p-4" style="max-width: 400px; width: 100%">
              <h4 class="text-center mb-3">OTP Verification</h4>
              <p class="text-center">
                Enter the 4-digit OTP sent to your Phone Number.
              </p>
              <div class="d-flex justify-content-center">
                <input
                  v-for="(digit, index) in otp"
                  :key="index"
                  v-model="otp[index]"
                  type="text"
                  class="form-control otp-input"
                  maxlength="1"
                  :ref="(el) => setOtpRef(el, index)"
                  @input="moveFocus(index)"
                  @keydown.backspace="handleBackspace(index)"
                />
              </div>
              <div
                :class="'alert alert-' + msgType + ' mb-xl-0 mt-2'"
                role="alert"
                v-if="msgTxt && msgTxt.length > 0"
              >
                {{ msgTxt }}
              </div>
              <button
                class="btn btn-warning w-100 mt-3"
                style="height: 50px"
                @click="validateOtp"
              >
                <div v-if="loading" class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span v-else>VERIFY OTP</span>
              </button>
              <p class="text-center mt-2 text-danger" v-if="otpExpiryTime > 0">
                OTP expires in {{ formattedOtpExpiry }}
              </p>
              <p class="text-center mt-3">
                Didn't receive the code?
                <a
                  href="#"
                  :class="{ disabled: !canResend }"
                  style="pointer-events: v-bind(canResend ? 'auto': 'none')"
                  @click.prevent="resendOTP"
                  >Resend</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4 text-center">
        <p class="subtitle">
          <span class="mdi mdi-copyright"></span>
          Yellowboards Pvt.Ltd. All Rights Reserved. Made With Love in
          <strong>Tamilnadu</strong>
        </p>
      </div>
    </div>
    <ToastNotification ref="toast" />

    <div style="width: 50%" class="right-side"></div>
  </div>
</template>

<script>
import { sendOtp, verifyOtp } from "@/apis/loginapis";
import { mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import Cookies from "js-cookie";
import { mapActions } from "pinia";
import useVuelidate from "@vuelidate/core";
import { required, numeric, minLength, maxLength } from "@vuelidate/validators";
export default {
  name: "adminLogin",

  methods: {
    ...mapActions(useAuthStore, [
      "setLdata",
      "setErrorMessage",
      "startLoading",
      "stopLoading",
      "clearErrorMessage",
    ]),

    async sendOTP() {
      this.startLoading();
      const response = await sendOtp("admin", this.phone);
      if (response.success) {
        this.isOtpSent = true;
        this.startOtpCountdown();
        this.userId = response.userId;
        this.clearErrorMessage();
        this.$refs.toast?.showToast(`OTP Sent Successfully`, "success");
      } else {
        this.setErrorMessage(response.message, "danger");
        this.$refs.toast?.showToast(`Failed to Sent OTP`, "error");
      }
      this.stopLoading();
    },

    async validateOtp() {
      this.startLoading();
      const response = await verifyOtp("admin", this.userId, this.otp.join(""));
      if (response.status) {
        ``;
        Cookies.set("accessToken", response.accessToken, {
          expires: 7,
          secure: true,
        });

        Cookies.set("refreshToken", response.refreshToken, {
          expires: 30,
          secure: true,
        });

        localStorage.setItem("ldata", JSON.stringify(response.user));

        window.location.href = "/";

        this.clearErrorMessage();
      } else {
        this.clearOtpFields();
        this.setErrorMessage(response.message, "danger");
      }
      this.stopLoading();
    },

    clearOtpFields() {
      this.otp = Array(4).fill("");
      this.$nextTick(() => {
        this.otpInputs[0]?.focus();
      });
    },

    setOtpRef(el, index) {
      if (el) this.otpInputs[index] = el;
    },

    moveFocus(index) {
      if (this.otp[index] && index < this.otp.length - 1) {
        this.$nextTick(() => {
          this.otpInputs[index + 1]?.focus();
        });
      }
    },

    handleBackspace(index) {
      if (!this.otp[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs[`otpInput${index - 1}`]?.focus();
        });
      }
    },

    startOtpCountdown() {
      this.otpExpiryTime = 300;

      if (this.otpTimer) clearInterval(this.otpTimer);

      this.otpTimer = setInterval(() => {
        if (this.otpExpiryTime > 0) {
          this.otpExpiryTime--;
        } else {
          clearInterval(this.otpTimer);
          this.otpTimer = null;
          this.$refs.toast?.showToast("OTP expired. Please resend.", "error");
        }
      }, 1000);
    },

    stopOtpCountdown() {
      if (this.otpTimer) {
        clearInterval(this.otpTimer);
        this.otpTimer = null;
      }
    },

    resendOTP() {
      if (!this.canResend) return;

      this.sendOTP();
      this.clearOtpFields();

      this.attempt += 1;
      this.canResend = false;

      if (this.attempt === 1) {
        this.startTimer(30);
      } else if (this.attempt === 2) {
        this.startTimer(60);
      } else if (this.attempt === 3) {
        this.startTimer(120);
      } else {
        this.startTimer(1800);
      }
    },

    startTimer(seconds) {
      this.timer = seconds;
      if (this.timerInterval) clearInterval(this.timerInterval);

      this.timerInterval = setInterval(() => {
        this.timer -= 1;
        if (this.timer <= 0) {
          clearInterval(this.timerInterval);
          this.canResend = true;
        }
      }, 1000);
    },
  },
  data() {
    return {
      otp: Array(4).fill(""),
      isOtpSent: false,
      otpInputs: [],
      v$: null,
      phone: null,
      userId: null,
      otpExpiryTime: 300,
      otpTimer: null,

      attempt: 0,
      canResend: true,
      timer: 0,
      timerInterval: null,
    };
  },

  computed: {
    ...mapState(useAuthStore, ["msgTxt", "msgType", "loading"]),

    formattedOtpExpiry() {
      const minutes = Math.floor(this.otpExpiryTime / 60);
      const seconds = this.otpExpiryTime % 60;
      return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    },
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },

  beforeUnmount() {
    this.stopOtpCountdown();

    if (this.timerInterval) clearInterval(this.timerInterval);
  },

  validations: {
    phone: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
  },
};
</script>

<style scoped>
.otp-input {
  width: 50px;
  height: 50px;
  text-align: center;
  font-size: 20px;
  margin: 0 5px;
}
.disabled-btn {
  background-color: rgb(215, 214, 214) !important;
  border-color: rgb(194, 194, 194) !important;
  color: white !important;
  cursor: not-allowed;
}

.right-side {
  background: url("/public/images/image13.png");
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
}
.subtitle {
  font-size: 12px;
  color: rgb(169, 169, 169);
}
.gradient-vertical {
  background: linear-gradient(to bottom, #ffffff 60%, #fff9db 100%);
}
.disabled {
  color: gray !important;
  text-decoration: none;
  cursor: not-allowed;
}
</style>
